import { render } from "./Articles.vue?vue&type=template&id=a683372c&scoped=true"
import script from "./Articles.vue?vue&type=script&lang=js"
export * from "./Articles.vue?vue&type=script&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=a683372c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a683372c"]])

export default __exports__